import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from '@narvar/moment-shim';
import { receivePickupDateSelection } from '../../actions/pickupAddon';
import { NUMBER_OF_PICKUP_DAYS } from '../../constants/pickups';
import { PickupCalendarContainer } from './PickupStyles';
import PickupCarousel from './PickupCarousel';

const mapStateToProps = ({
  retailerSettings: { branding: { brand_call_to_action: ctaColor } = {} } = {},
  pickupAddon: {
    options: { date: dates },
    form: { date: selectedDate },
  },
}) => ({ selectedDate, dates, ctaColor });

const CalendarDate = ({ date, disabled, selected, ctaColor, onClick }) => {
  const momentDate = moment(date);
  const dayOfWeek = momentDate.format('ddd');
  const monthAndDay = momentDate.format('MMM D');

  return (
    <PickupCalendarContainer
      disabled={disabled}
      selected={selected}
      ctaColor={ctaColor}
      onClick={onClick}
    >
      <strong>{dayOfWeek}</strong>
      <div style={{ fontSize: '0.75rem' }}>{monthAndDay}</div>
    </PickupCalendarContainer>
  );
};

CalendarDate.defaultProps = {
  disabled: false,
  selected: false,
  ctaColor: '#000000',
  onClick: () => {},
};

CalendarDate.propTypes = {
  date: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  ctaColor: PropTypes.string,
  onClick: PropTypes.func,
};

const PickupDatePicker = ({ dispatch, selectedDate, dates, ctaColor }) => (
  <PickupCarousel
    items={dates}
    render={({ date, eligible }) => (
      <CalendarDate
        disabled={!eligible}
        date={date}
        ctaColor={ctaColor}
        selected={selectedDate === date}
        onClick={() => {
          if (!eligible) return;
          dispatch(receivePickupDateSelection(date));
        }}
      />
    )}
    slidesToShow={NUMBER_OF_PICKUP_DAYS}
  />
);

PickupDatePicker.defaultProps = {
  ctaColor: '#000000',
};

PickupDatePicker.propTypes = {
  dispatch: PropTypes.func.isRequired,
  selectedDate: PropTypes.string.isRequired,
  dates: PropTypes.arrayOf(
    PropTypes.shape({ date: PropTypes.string.isRequired, eligible: PropTypes.bool.isRequired }),
  ).isRequired,
  ctaColor: PropTypes.string,
};

export default connect(mapStateToProps)(PickupDatePicker);
